import Immutable from 'seamless-immutable';
import pubnub from '../pubnub';
import { SubmissionError } from 'redux-form'; // ES6
import firebase from '../firebase';
import { ValidationError } from '../utility';

const ActionTypes = {
  NEW_USER_CREATED: 'NEW_USER_CREATED',
  CURRENT_USER_LOGIN: 'CURRENT_USER_LOGIN',
  CURRENT_USER_LOGOUT: 'CURRENT_USER_LOGOUT',
};

const Private = {
  db: firebase.firestore(),
  usersRef: firebase.firestore().collection('users'),
  query: null,
  currentUserRef: () => {
    const user = firebase.auth().currentUser;
    const uid = user.uid;
    return Private.usersRef.doc(uid);
  },
  usernameQuery: username =>
    Private.usersRef.where('usernameLower', '==', username.toLowerCase()),
  existingUsername: username => {
    return Private.usernameQuery(username)
      .get()
      .then(snapshot => {
        if (snapshot && snapshot.docs && snapshot.docs.length > 0) {
          throw new ValidationError('Username not available', 'username');
        }
        return true;
      });
  },
};

const Actions = {
  creators: {
    newUserCreated: data => ({
      data,
      type: ActionTypes.NEW_USER_CREATED,
    }),
    currentUserLogin: data => ({
      data,
      type: ActionTypes.CURRENT_USER_LOGIN,
    }),
    currentUserLogout: () => ({
      type: ActionTypes.CURRENT_USER_LOGOUT,
    }),
  },
  thunks: {
    createNewUser: data => dispatch => {
      const { email, password, username, name } = data;
      const usernameLower = username.toLowerCase();
      return firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(result => {
          const data = {
            email,
            username,
            usernameLower,
            name,
          };
          return Promise.resolve(data);
        })
        .then(data =>
          Private.usersRef.doc(firebase.auth().currentUser.uid).set(data),
        )
        .then(doc =>
          Private.usersRef.doc(firebase.auth().currentUser.uid).get(),
        )
        .then(doc => {
          const id = doc.id;
          const user = Object.assign({ id }, doc.data());
          pubnub.setUUID(id);
          console.log('user: user', user);
          dispatch(Actions.creators.newUserCreated(user));
          return user;
        })
        .catch(error => {
          console.error('ERROR: ', error);
          if (firebase.auth().currentUser) {
            // delete both since we had a signup error
            Private.currentUserRef().delete();
            firebase.auth().currentUser.delete();
          }
          throw new SubmissionError(error);
        });
    },
    loginUser: data => dispatch => {
      const { email, password } = data;
      return firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(() => Private.currentUserRef().get())
        .then(doc => {
          const id = doc.id;
          const user = Object.assign({ id }, doc.data());
          pubnub.setUUID(id);
          dispatch(Actions.creators.currentUserLogin(user));
          return user;
        })
        .catch(error => {
          throw new SubmissionError({ login: 'Does not exist' });
        });
    },
    logoutUser: data => dispatch => {
      return firebase
        .auth()
        .signOut()
        .then(() => {
          dispatch(Actions.creators.currentUserLogout());
          return true;
        });
    },
  },
};

export { Actions };

const defaultState = Immutable({});
export default (state = defaultState, action) => {
  if (action.type === ActionTypes.NEW_USER_CREATED) {
    return action.data;
  } else if (action.type === ActionTypes.CURRENT_USER_LOGIN) {
    return action.data;
  } else if (action.type === ActionTypes.CURRENT_USER_LOGOUT) {
    return null;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/ducks/currentUser.js